import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@/fontawesome'
import Modal from '@/components/ui/Modal'

const STORAGE_KEY = `bolzai_${import.meta.env.VITE_NAMESPACE}_tradingDisclaimer`

export default function TradingDisclaimerModal() {
  const [isOpen, setIsOpen] = useState(() => sessionStorage.getItem(STORAGE_KEY) === null)

  const handleAccept = () => {
    sessionStorage.setItem(STORAGE_KEY, '1')
    setIsOpen(false)
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleAccept}
      title="Wichtiger Hinweis"
      icon={<FontAwesomeIcon icon={faTriangleExclamation} className="w-5 h-5 text-yellow-600" />}
      maxWidth="md"
      closeDisabled={true}
    >
      <div className="p-6">
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          Die Tradingideen sind keine finanzielle Beratung oder bilden eine Handlungsempfehlung ab.
          Jedes Mitglied, trifft Entscheidungen bezüglich seiner/ihrer Anlagestrategie aufgrund von
          Informationen oder Kommentaren in dem Schulungsmaterial in eigener Verantwortung.
        </p>
        <p className="text-gray-700 dark:text-gray-300 mb-6">
          Das bedeutet wiederum, dass weder der/die Vorsitzende noch die Sven Bolz Trading Academy
          für einen Verlust haftet.
        </p>
        <div className="flex justify-end">
          <button
            onClick={handleAccept}
            className="px-6 py-2 text-sm font-medium rounded-lg bg-blue-600 text-white hover:bg-blue-700 cursor-pointer transition-colors"
          >
            Verstanden
          </button>
        </div>
      </div>
    </Modal>
  )
}
